import React from 'react';
import {Route, IndexRoute} from 'react-router';

import App from './components/App';
import NotFoundPage from './components/NotFoundPage';
import Login from './components/auth/Login';

import Leads from './components/tabs/leads/Leads';
import Users from './components/tabs/users/Users';
import Companies from './components/tabs/companies/Companies';
import Analytics from './components/tabs/analytics/Analytics';

export default (
    <Route path="/" component={App}>
        <IndexRoute component={Leads}/>
        <Route path="leads" component={Leads}/>
        <Route path="users(/:user_link)" component={Users}/>
        <Route path="companies(/:company_link)" component={Companies}/>
        <Route path="analytics" component={Analytics}/>
        <Route path="login" component={Login}/>
        <Route path="*" component={NotFoundPage}/>
    </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js